var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5002L13.8809 13.881M13.8809 13.881C14.5 13.2619 14.991 12.527 15.3261 11.7181C15.6611 10.9093 15.8336 10.0423 15.8336 9.16684C15.8336 8.29134 15.6611 7.42441 15.3261 6.61555C14.991 5.80669 14.5 5.07174 13.8809 4.45267C13.2618 3.8336 12.5269 3.34252 11.718 3.00748C10.9091 2.67244 10.0422 2.5 9.16672 2.5C8.29121 2.5 7.42429 2.67244 6.61543 3.00748C5.80657 3.34252 5.07162 3.8336 4.45255 4.45267C3.20227 5.70295 2.49988 7.39868 2.49988 9.16684C2.49988 10.935 3.20227 12.6307 4.45255 13.881C5.70282 15.1313 7.39856 15.8337 9.16672 15.8337C10.9349 15.8337 12.6306 15.1313 13.8809 13.881Z",
    stroke: "#3A86FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.474631d501019721c0f07fd4691e2271.svg";
export { ForwardRef as ReactComponent };